module.exports = __webpack_public_path__ + "static/media/mastercard.db4c8702.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/mastercard.png
// module id = 1548
// module chunks = 0